












































































  import Vue from 'vue'

  import TheHeader from './components/TheHeader.vue'
  import TheFooter from './components/TheFooter.vue'
  import TheNavigation from './components/TheNavigation.vue'
  import ASection from './components/ASection.vue'
  import TheExplorer from './components/TheExplorer.vue'
//   import { DxPopup } from 'devextreme-vue/popup'

  export default Vue.extend({
    components: {TheHeader, TheFooter, TheNavigation, ASection, TheExplorer},
    data() { 
      return {
        message: 'Hello Vue!'
      }
    },
    methods: {

    }
  })
